import React from "react";
import { Input } from "@/shared/components/ui/input";
import { Label } from "@/shared/components/ui/label";
import { Textarea } from "@/shared/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import { Switch } from "@/shared/components/ui/switch";

const GeneralInfo = ({ formData, handleChange, t }) => {
  return (
    <div className="space-y-4 mt-4">
      <div className="space-y-2">
        <Label>{t("providerNameRequired")}</Label>
        <Input
          value={formData.name}
          onChange={(e) => handleChange("name", e.target.value)}
          placeholder={t("providerNamePlaceholder")}
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>{t("providerCodeRequired")}</Label>
          <Input
            value={formData.code}
            onChange={(e) => handleChange("code", e.target.value.toUpperCase())}
            placeholder={t("providerCodePlaceholder")}
          />
        </div>
        <div className="space-y-2">
          <Label>{t("type")}</Label>
          <Select
            value={formData.type}
            onValueChange={(v) => handleChange("type", v)}
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="bank">{t("bank")}</SelectItem>
              <SelectItem value="ewallet">
                {t("providerTypeEwallet")}
              </SelectItem>
              <SelectItem value="qr">{t("providerTypeQr")}</SelectItem>
              <SelectItem value="card">{t("providerTypeCard")}</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>{t("status")}</Label>
          <Select
            value={formData.status}
            onValueChange={(v) => handleChange("status", v)}
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="active">{t("active")}</SelectItem>
              <SelectItem value="inactive">{t("inactive")}</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label>{t("logoUrl")}</Label>
          <Input
            value={formData.logo_url}
            onChange={(e) => handleChange("logo_url", e.target.value)}
            placeholder={t("logoUrlPlaceholder")}
          />
        </div>
      </div>

      <div className="space-y-4 p-4 bg-slate-50 rounded-lg">
        <div className="flex items-center justify-between">
          <div>
            <Label>{t("supportsDeposits")}</Label>
            <p className="text-sm text-slate-500">
              {t("processDepositTransactions")}
            </p>
          </div>
          <Switch
            checked={formData.supports_deposit}
            onCheckedChange={(v) => handleChange("supports_deposit", v)}
          />
        </div>
        <div className="flex items-center justify-between">
          <div>
            <Label>{t("supportsWithdrawals")}</Label>
            <p className="text-sm text-slate-500">
              {t("processWithdrawalTransactions")}
            </p>
          </div>
          <Switch
            checked={formData.supports_withdrawal}
            onCheckedChange={(v) => handleChange("supports_withdrawal", v)}
          />
        </div>
        <div className="flex items-center justify-between">
          <div>
            <Label>{t("supportsQr")}</Label>
            <p className="text-sm text-slate-500">{t("generatePromptPayQr")}</p>
          </div>
          <Switch
            checked={formData.supports_qr}
            onCheckedChange={(v) => handleChange("supports_qr", v)}
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label>{t("notes")}</Label>
        <Textarea
          value={formData.notes}
          onChange={(e) => handleChange("notes", e.target.value)}
          rows={3}
        />
      </div>
    </div>
  );
};

export default GeneralInfo;
